module.exports = __webpack_public_path__ + "static/img/oris.57d7585e.png";